import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FinancialConsultingPage = lazy(() => import('../pages/financial-consulting/page'));
const ManagementConsultingPage = lazy(() => import('../pages/management-consulting/page'));
const GeographyPage = lazy(() => import('../pages/geography/page'));
const ContactsPage = lazy(() => import('../pages/contacts/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/financial-consulting',
    element: <FinancialConsultingPage />,
  },
  {
    path: '/management-consulting',
    element: <ManagementConsultingPage />,
  },
  {
    path: '/geography',
    element: <GeographyPage />,
  },
  {
    path: '/contacts',
    element: <ContactsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
